// pages/NotFoundPage.jsx
import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import PageShell from "../components/PageShell";

/**
 * 404 Not Found Page
 */
export default function NotFoundPage() {
  return (
    <PageShell title="Page Not Found" bannerImage="404.png">
      <Stack alignItems="center" spacing={3} sx={{ textAlign: "center", py: 6 }}>
        <Box
          component="img"
          src="car_crash.png"
          alt="404 Illustration"
          sx={{ maxWidth: 300, mb: 2, opacity: 0.8 }}
        />
        <Typography variant="h4" sx={{ fontWeight: 800 }}>
          Oops! You took a wrong turn.
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500 }}>
          The page you’re looking for doesn’t exist or may have been moved.
        </Typography>
        <Button variant="contained" color="primary" component={RouterLink} to="/">
          Back to Home
        </Button>
      </Stack>
    </PageShell>
  );
}
